import { Button } from '@workspace/ui/components/button';
import { Icon, useToast } from '@/src/components/ui';
import { useCopyToClipboard } from '@/src/hooks/use-copy-to-clipboard';

type Props = {
  slug: string;
  className?: string;
  type?: 'project' | 'bit';
};

export const ShareLink = ({ slug, className, type }: Props) => {
  const { copy } = useCopyToClipboard();
  const toast = useToast();
  const handleShareClick = () => {
    copy(`https://player3.io/${type}/${slug}`);
    toast.success('Link copied successfully');
  };
  return (
    <Button
      variant="outline"
      size="sm"
      className={`w-fit h-fit px-2 text-black/80 bg-transparent flex shadow-none items-center justify-start gap-1 ${className}`}
      onClick={handleShareClick}
    >
      <Icon name="share" className="size-4 md:mr-2 text-black/40" />
      Share
    </Button>
  );
};
